ci_states.state('application', {
    url: '/applications?platform&q',
    templateUrl: 'partials/application/application_list.html',
    controller: 'ApplicationListController',
    reloadOnSearch: true,
    ncyBreadcrumb: {
        label: 'Applications'
    }
}).state('application_wizard', {
    url: '/applications/:id/setup?customer&init_step?doc',
    templateUrl: 'partials/application/wizard/view.html',
    controller: 'ApplicationWizardCtrl',
    ncyBreadcrumb: {
        parent: function ($scope) {
            if ($scope.stateParams && $scope.stateParams.id) {
                return 'application_view.general({id:' + $scope.stateParams.id + '})';
            } else {
                return 'application_view.general()';
            }
        },
        label: 'SDK Setup'
    }
}).state('application_wizard_migration_notes_android', {
    url: '/applications/:id/setup/migration_notes',
    params: {
        isApp: true
    },
    templateUrl: 'partials/application/wizard/android_migration_notes.html',
    controller: 'SdkMigrationNotesAndroidController',
    ncyBreadcrumb: {
        parent: function ($scope) {
            if ($scope.stateParams && $scope.stateParams.id) {
                return 'application_wizard({id:' + $scope.stateParams.id + '})';
            } else {
                return 'application_wizard()';
            }
        },
        label: 'Android SDK Migration Notes'
    }
}).state('application_wizard_custom_firebase_setup', {
    url: '/applications/:id/setup/custom_firebase_setup',
    params: {
        isApp: true
    },
    templateUrl: 'partials/application/wizard/android_custom_firebase_setup.html',
    controller: 'SdkMigrationNotesAndroidController',
    ncyBreadcrumb: {
        parent: function ($scope) {
            if ($scope.stateParams && $scope.stateParams.id) {
                return 'application_wizard({id:' + $scope.stateParams.id + '})';
            } else {
                return 'application_wizard()';
            }
        },
        label: 'Custom Firebase Setup'
    }
}).state('application_wizard_token', {
    url: '/applications/setup?token?step&customer',
    templateUrl: 'partials/application/wizard/view.html',
    controller: 'ApplicationWizardCtrl',
    ncyBreadcrumb: {
        parent: 'application',
        label: 'Create'
    }
}).state('application_view', {
    url: '/applications/:id?start_date&end_date',
    abstract: true,
    templateUrl: 'partials/application/application_view.html',
    controller: 'ApplicationViewController',
    reloadOnSearch: true,
    ncyBreadcrumb: {
        parent: 'application',
        label: "{{ application.app_name || app.app_name }}"
    }
}).state('application_view.base', {
    url: '',
    redirectTo: 'application_view.general'
}).state('application_view.test_devices', {
    url: '/test_devices',
    templateUrl: 'partials/test_device/test_device_list.html',
    controller: 'TestDeviceListController',
    ncyBreadcrumb: {
        label: 'Test Devices'
    }
}).state('application_view.settings', {
    url: '/settings',
    templateUrl: 'partials/application/application_view_settings.html',
    ncyBreadcrumb: {
        label: 'Settings'
    }
}).state('application_view.general', {
    url: '/analytics',
    controller: 'AnalyticsListController',
    templateUrl: 'partials/application/application_view_analytics.html',
    ncyBreadcrumb: {
        label: 'Analytics'
    }
}).state('application_view.custom_events', {
    url: '/custom_events',
    templateUrl: 'partials/custom_event/custom_event_list.html',
    ncyBreadcrumb: {
        label: 'Custom Events'
    }
}).state('application_view.recent_activity', {
    url: '/recent_activity',
    controller: 'ApplicationRecentActivityController',
    templateUrl: 'partials/application/application_view_recent_activity.html',
    ncyBreadcrumb: {
        label: 'Recent Activity'
    }
}).state('application_view.segments', {
    url: '/segments',
    controller: 'SegmentListController',
    templateUrl: 'partials/segment/segment_list.html',
    ncyBreadcrumb: {
        label: 'Segments'
    }
}).state('application_view.retention', {
    url: '/retention/:retention_id',
    ncyBreadcrumb: {
        label: 'Cohorts'
    },
    controller: 'RetentionViewController',
    templateUrl: 'partials/retention/retention_view.html'
}).state('application_view.reengagement', {
    url: '/reengagement',
    abstract: true,
    controller: 'reengagementFormController',
    templateUrl: 'partials/reengagement/reengagement_view.html',
    ncyBreadcrumb: {
        label: 'Reengagement'
    }
}).state('application_view.reengagement.edit', {
    url: '/:reengagement_id',
    templateUrl: 'partials/reengagement/reengagement_edit.html',
    ncyBreadcrumb: {
        label: 'Edit'
    }
}).state('application_view.reengagement.push_history', {
    url: '/:reengagement_id/push_history',
    controller: 'PushNotificationHistory',
    templateUrl: 'partials/reengagement/reengagement_view_push_notification_instances.html',
    ncyBreadcrumb: {
        label: 'Push Notification Send History'
    }
}).state('application_view.segment_groups', {
    url: '/segment_groups',
    controller: 'SegmentGroupListController',
    templateUrl: 'partials/segment_group/segment_group_list.html',
    ncyBreadcrumb: {
        label: 'Segment Groups'
    }
}).state('application_view.push_notifications', {
    url: '/notifications',
    templateUrl: 'partials/push_notification/push_notification_list.html',
    ncyBreadcrumb: {
        label: 'Push Notifications'
    }
}).state('application_view.push_notifications_history', {
    url: '/notifications/:id',
    templateUrl: 'partials/push_notification/push_notification_list.html',
    ncyBreadcrumb: {
        label: 'Push Notifications'
    }
});
